module.exports = __webpack_public_path__ + "img/4683a34140df2e38a5da18ca88c18eb2.png";